import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "block my-4" }
const _hoisted_3 = { class: "flex h-4/5" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "w-1/6" }
const _hoisted_6 = { class: "w-1/2" }
const _hoisted_7 = { class: "flex items-end" }
const _hoisted_8 = { class: "ml-2 text-xs text-gray-500" }
const _hoisted_9 = { class: "w-1/6" }
const _hoisted_10 = { class: "w-1/6" }
const _hoisted_11 = { class: "flex flex-col w-96 gap-y-2" }
const _hoisted_12 = { class: "flex gap-x-2" }
const _hoisted_13 = { class: "flex gap-x-2" }

import Modal from '@/components/Modal/Modal.vue';
import TextField from '@/components/Inputs/TextField.vue';
import { computed, inject, onMounted, Ref, ref } from 'vue';
import { cloneDeep } from 'lodash';
import Button from '@/components/UI/Button.vue';
import { useWrestlerStore } from '@/store/wrestlers';
import { useBrandStore } from '@/store/brands';
import { Wrestler } from '@/typings/wrestler';
import SearchDropdown from '@/components/Inputs/SearchDropdown.vue';
import { SearchItem } from '@/typings/dropdown';
import { PromptModal } from '@/typings/modal';
import VirtualList from '@/components/UI/VirtualList.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const promptModal = inject('promptModal') as Ref<PromptModal>;

const creationModalVisible = ref(false);
const newWrestler = ref();

const wrestlerStore = useWrestlerStore();
const brandStore = useBrandStore();

const statuses = ref<SearchItem[]>([
  { text: 'Active', value: 1 },
  { text: 'Retired', value: 2 },
  { text: 'Deceased', value: 3 },
  { text: 'HOF', value: 4 },
  { text: 'Staff', value: 5 },
]);

const brands = ref<SearchItem[]>([]);

function getStatusName(status: number) {
  if (status >= 1 && status <= 5) {
    return statuses.value.filter((x) => x.value === status)[0].text;
  }
  return '-';
}

function getBrandName(id: number) {
  return brandStore.brands.find((b) => b.CompanyId === id)?.Name || 'None';
}

function openCreate() {
  newWrestler.value = {
    CompanyId: brands.value[0].value,
    Status: statuses.value[0].value,
    SocialName: '',
    Name: '',
  };
  creationModalVisible.value = true;
}

function editWrestler(editingWrestler: Wrestler) {
  newWrestler.value = cloneDeep(editingWrestler);
  creationModalVisible.value = true;
}

async function deleteWrestler(deletingWrestler: Wrestler) {
  const doDelete = await promptModal.value.show(
    'Remove Wrestler',
    'You are about to remove a wrestler, are you sure?'
  );
  if (doDelete) {
    await wrestlerStore.deleteWrestler(deletingWrestler);
  }
}

async function saveModal() {
  if (newWrestler.value.SuperstarId) {
    await wrestlerStore.editWrestler(newWrestler.value);
  } else {
    await wrestlerStore.addWrestler(newWrestler.value);
  }
  creationModalVisible.value = false;
}

const modalHeader = computed(() =>
  newWrestler.value?.CompanyId ? 'Edit a wrestler' : 'Set up a wrestler'
);

onMounted(async () => {
  if (brandStore.brands.length === 0) await brandStore.getBrands();
  brands.value = brandStore.brands.map((b) => ({
    value: b.CompanyId,
    text: b.Name,
  }));
  wrestlerStore.getWrestlers();
});

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Button, {
          label: "Add Wrestler",
          onClick: openCreate
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(VirtualList, {
          ref: (_value, _refs) => {
            _refs['list'] = _value
          },
          "item-size": 36,
          data: _unref(wrestlerStore).wrestlers,
          "data-key": "SuperstarId"
        }, {
          default: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(getBrandName(item.CompanyId)), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, _toDisplayString(item.Name), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(item.SocialName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(getStatusName(item.Status)), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(Button, {
                  class: "cursor-pointer",
                  onClick: ($event: any) => (editWrestler(item))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_fa_icon, { icon: "pencil-alt" })
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(Button, {
                  class: "cursor-pointer",
                  onClick: ($event: any) => (deleteWrestler(item))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_fa_icon, { icon: "trash" })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ]),
    (newWrestler.value && creationModalVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          header: _unref(modalHeader),
          onClose: _cache[5] || (_cache[5] = ($event: any) => (creationModalVisible.value = false))
        }, {
          footer: _withCtx(() => [
            _createVNode(Button, {
              label: "Save",
              onClick: saveModal
            }),
            _createVNode(Button, {
              label: "Cancel",
              type: "secondary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (creationModalVisible.value = false))
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(TextField, {
                  modelValue: newWrestler.value.Name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newWrestler.value.Name) = $event)),
                  title: "Name",
                  "max-length": 150
                }, null, 8, ["modelValue"]),
                _createVNode(TextField, {
                  modelValue: newWrestler.value.SocialName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newWrestler.value.SocialName) = $event)),
                  title: "Twitter Name",
                  "max-length": 36
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(SearchDropdown, {
                  title: "Brand",
                  modelValue: newWrestler.value.CompanyId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newWrestler.value.CompanyId) = $event)),
                  items: brands.value
                }, null, 8, ["modelValue", "items"]),
                _createVNode(SearchDropdown, {
                  title: "Status",
                  modelValue: newWrestler.value.Status,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newWrestler.value.Status) = $event)),
                  items: statuses.value
                }, null, 8, ["modelValue", "items"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})